import { numberFormatter } from "../../../helpers";

export const initialState = {
  isShowMealMenuBox: false,
  currentPassenger: null,
  currentPhysicalFlightId: 0
}

export function reducer(state, action) {
  switch (action.type) {
    case 'SHOW_MEALS_MENU':
      return {
        isShowMealMenuBox: true,
        currentPassenger: action.passenger,
        currentPhysicalFlightId: action.physicalFlightId
      }
    case 'HIDE_MEALS_MENU':
      return {
        isShowMealMenuBox: false,
        currentPassenger: null,
        currentPhysicalFlightId: 0
      }
    default:
      return state
  }
}


export function calculateTotalAmount(selection) {
  let total = 0;
  selection && selection.forEach(flight => {
    flight.passengers.forEach(pax => {
      if(!Array.isArray(pax.meals)) return;
      pax.meals.forEach(meal => {
        if(meal.selected) total += meal.amount;
      });
    });
  });

  return numberFormatter.formatCurrency(total);
}

export function clearMealSelection(selection) {
  if(!Array.isArray(selection)) return 0;

  let cleared = 0;
  selection.forEach(flight => {
    flight.passengers.forEach(pax => {
      if (!Array.isArray(pax.meals)) return;
      pax.meals.forEach(meal => {
        if (!meal.purchased) {
          meal.selected = false;
          cleared++;
        }
      });
    });
  });
  return cleared;
}

export function getChangedMeals(booking, selection) {
  const changed = [];

  if (!booking || !Array.isArray(selection)) return;

  selection.forEach(flight => {

    const segment = booking.segments.find(s => s.logicalFlightId === flight.logicalFlightId)
    if (!segment) return

    flight.passengers.forEach(pax => {
      if (!Array.isArray(pax.meals)) return;

      segment.legs.forEach(leg => {
        const selected = pax.meals.find(m => m.selected && m.physicalFlightId === leg.physicalFlightId);

        if (selected) { // added
          changed.push({
            passengerId: pax.id,
            logicalFlightId: flight.logicalFlightId,
            physicalFlightId: leg.physicalFlightId,
            ssrCode: selected.ssrCode
          })
        }
        else {  // remove or no change
          changed.push({
            passengerId: pax.id,
            logicalFlightId: flight.logicalFlightId,
            physicalFlightId: leg.physicalFlightId,
            ssrCode: null
          })
        }
      })
    });
  });

  return changed
}

export function selectMealForPassenger(currentPassenger, meal) {
  if (!currentPassenger || !Array.isArray(currentPassenger.meals)) return false;

  const paxMeals = currentPassenger.meals.filter(m => m.physicalFlightId === meal.physicalFlightId);

  if (meal.ssrCode) { // select/change meal
    paxMeals.forEach(m => {
      if (m.ssrCode === meal.ssrCode) {
        m.selected = true;
      }
      else {
        m.selected = false;
      }
    });
  }
  else { // remove meal
    paxMeals.forEach(m => {
      m.selected = m.purchased || m.included;
    })
  }

  return true
}
